import React from "react"
import { useTranslation } from "react-i18next"

import { Anchor } from "shared/ui/link/Anchor"

import { useProjectPageProductPositionSidebarContext } from "./ProjectPageProductPositionSidebarContext"

export const ProductPositionSidebarImage = React.memo(() => {
  const { t } = useTranslation()
  const { image, titleLinkProps } =
    useProjectPageProductPositionSidebarContext() ?? {}

  if (!image) return null

  if (titleLinkProps) {
    return (
      <Anchor
        {...titleLinkProps}
        label={t("Product.OpenPage")}
        data-testid="project-page-sidebar__product-image-link"
        className="project-page-sidebar__product-image"
      >
        {image}
        <span className="project-page-sidebar__product-page-link">
          {t("Product.OpenPage")}
        </span>
      </Anchor>
    )
  }

  return (
    <div
      data-testid="project-page-sidebar__product-image"
      className="project-page-sidebar__product-image"
    >
      {image}
    </div>
  )
})
